import { render, staticRenderFns } from "./AuthorInput.vue?vue&type=template&id=c34d37aa"
import script from "./AuthorInput.vue?vue&type=script&lang=ts"
export * from "./AuthorInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports